import { Chip, Typography, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper } from '@mui/material'
import Iconify from '../../../Component/common/iconify/Iconify'
import { chipRender } from '../constants'

export default function StableBuildTargetTable({ stableBuildTargetMap }) {
  return (
    <TableContainer component={Paper} sx={{ mt: 4 }}>
      <Typography variant="h6" sx={{ m: 2 }}>Stable Build Targets</Typography>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Build Target</TableCell>
            <TableCell>Version</TableCell>
            <TableCell>Created Date</TableCell>
            <TableCell>APK</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.entries(stableBuildTargetMap).map(([key, release]) => (
            <TableRow key={key}>
              <TableCell>
                <Chip
                  size="small"
                  label={key.replace(/([A-Z])/g, ' $1').trim()}
                  variant="outlined"
                  icon={<Iconify icon={chipRender(key).icon} />}
                  color={chipRender(key).color}
                />
              </TableCell>
              <TableCell>
                {release?.appVersion ? `v${release.appVersion}` : 'N/A'}
                {release?.buildNumber ? ` ( ${release.buildNumber} )` : ''}
              </TableCell>
              <TableCell>
                {release?.createdDate ? new Date(release.createdDate).toLocaleDateString() : 'N/A'}
              </TableCell>
              <TableCell>
                {release?.file?.cosFileUrl ? (
                  <a href={release.file.cosFileUrl} target="_blank" rel="noopener noreferrer">
                    {release.file.cosFileUrl.split('/').pop()}
                  </a>
                ) : (
                  <Typography variant="body2" color="textSecondary">N/A</Typography>
                )}
              </TableCell>
            </TableRow>
          ))}
          {Object.keys(stableBuildTargetMap).length === 0 && (
            <TableRow>
              <TableCell colSpan={4} align="center">
                <Typography variant="body2" color="textSecondary">No stable builds found</Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  )
}